import TabPage from "./../factories/tab-page";
import "./../bindings/bao-date-time-box";
import "./../components/view-models/bao-color-picker";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-searcher";
import "./../bindings/bao-number-box";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import baoRouter from "./../services//bao-router";
class ShiftGroup extends BaseViewModelModule {
    ShiftPlanModelIdRouteValue: string;
    ShiftPlanModelName: KnockoutObservable<string>;
    ShiftPlanModelId = ko.observable('');
    Spdoffset = ko.observable(0);
    SpdreferenceDateJs = ko.observable('');
    IsEnableReferenceDateAndOffset = ko.observable(false);
    ShiftGroupColors: KnockoutObservableArray<string> = ko.observableArray([]);

    constructor(tabPage: TabPage) {
        super(tabPage);

        this.ShiftPlanModelIdRouteValue = baoRouter.getRouteValue('shiftplanmodelid', tabPage);
        this.subscribe(this.ShiftPlanModelId, (_) => {
            this.setOffsetAndReferenceDate();
        });
    }
    //ConfigurationItemTypeTab: Factories.TabPage;
    //ConfigurationItemTypeTabTitle = ko.observable<string>();     
    //TabController = new TabController(false);
    CompleteCheck() {
        var isComplete: boolean = true;
        //if (!isComplete) {
        //    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        //}
        return isComplete;
    }

    init() {
        return $.when(super.init(), this.LoadShiftColors()).then((_) => {
           
            if (this.IsNew()) {
                if (this.ShiftPlanModelIdRouteValue) {
                    // replaces url for new model when shiftPlanModelId is passed
                    const newHash = 'shiftgroup/' + this.PrimaryKeyValue() + '/' + this.ShiftPlanModelIdRouteValue;
                    baoRouter.replaceHash(newHash);

                    return this.GetShiftPlanModel(this.ShiftPlanModelIdRouteValue);
                }
            }
            return $.Deferred<void>().resolve().promise();
        });
    };

    InitUrl() {
        return "ShiftGroup/Init";
    }
    loaded() {
        super.loaded();
        //this.ConfigurationItemTypeTab = new TabPage();
        //this.ConfigurationItemTypeTab.Url("ActivityType/ConfigurationItemTypeTab");
        //this.TabController.AddTab(this.ConfigurationItemTypeTab);
    }



    private setOffsetAndReferenceDate() {
        const shiftPlanModelIdHasValue = Boolean(this.ShiftPlanModelId());
        if (!shiftPlanModelIdHasValue) {
            this.Spdoffset(0);
            this.SpdreferenceDateJs('');
        }
        this.IsEnableReferenceDateAndOffset(shiftPlanModelIdHasValue);
    }

    /*
     * Gets data for a ShiftPlanModel
     * */
    GetShiftPlanModel(shiftPlanModelId: string): JQueryPromise<void> {
        return Bao.post('ShiftPlanModel/Get', JSON.stringify({ id: shiftPlanModelId }),
            (model) => {
                if (!ko.unwrap(model.IsNew)) {
                    this.ShiftPlanModelId(ko.unwrap(model.ShiftPlanModelId));
                    this.ShiftPlanModelName(ko.unwrap(model.Name));
                }
            });
    }

    Save(): JQueryPromise<void> {
        const id = this.PrimaryKeyValue();
        return super.Save()
            .then((_) => this.RefreshShiftGroupTabOnShiftPlanModel(id));
    };

    Delete() {
        const id = this.PrimaryKeyValue();
        return super.Delete()
            .then((_) => this.RefreshShiftGroupTabOnShiftPlanModel(id));
    };

    /*
     * Sends an event about the need to (auto) refresh the Shift Group tab in the SHiftPlanModel view 
     * */
    private RefreshShiftGroupTabOnShiftPlanModel(id: any) {
        return Bao.raiseEvent('shiftplanmodelshiftgroup:refresh', { id });
    }

    GoToShiftPlanModel = () => {
        baoRouter.setHash("#shiftplanmodel/" + this.ShiftPlanModelId());
    }

    
    /*
     * this function is used to load the colors of the shift groups during initialization
     * */
    LoadShiftColors() {
        return Bao.post("ShiftType/GetShiftTypeColors")
            .then(result => {
                
                this.ShiftGroupColors(result.ShiftTypeColors);
            });
    }

}
export default ShiftGroup;